// TODO: move channel names here
export enum BotConnectionEnum {
    TestChat = 'Test Chat',
    TwilioMessages = 'Twillio (WhatsApp & SMS)',
    ChatBubble = 'Chat Bubble'
}